import React, { useEffect, useState } from "react";
import Header from "../Partial/Header";
import Footer from "../Partial/Footer";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3; // Show 3 blogs per page

  useEffect(() => {
    // Simulate API call with dummy data
    const timeout = setTimeout(() => {
      const dummyBlogs = [
        {
          id: 1,
          title: "Understanding Capacitors in Electronics",
          short_description:
            "Capacitors play a vital role in smoothing power supply and filtering signals in electronic circuits. Learn how they function.",
          image_url: "https://i.ibb.co/bjTh7M0z/cap1.png",
          created_at: "2025-07-15T10:00:00Z",
        },
        {
          id: 2,
          title: "Why Film Capacitors Are Preferred in Audio Systems",
          short_description:
            "Film capacitors are known for stability and low distortion. Discover why audiophiles and engineers love them.",
          image_url: "https://i.ibb.co/bjTh7M0z/cap2.png",
          created_at: "2025-06-28T09:00:00Z",
        },
        {
          id: 3,
          title: "Choosing the Right Capacitor for Your Project",
          short_description:
            "From ceramic to electrolytic, choosing the correct capacitor type and rating is crucial. Here's a guide to help you.",
          image_url: "https://i.ibb.co/bjTh7M0z/cap3.png",
          created_at: "2025-07-10T15:30:00Z",
        },
        {
          id: 4,
          title: "How to Store Capacitors Safely",
          short_description:
            "Proper storage extends capacitor life and prevents degradation. Here's what you need to know.",
          image_url: "https://i.ibb.co/bjTh7M0z/cap1.png",
          created_at: "2025-07-01T12:00:00Z",
        },
        {
          id: 5,
          title: "Capacitor Testing Methods",
          short_description:
            "Understand how to measure capacitance, ESR, and leakage current accurately.",
          image_url: "https://i.ibb.co/bjTh7M0z/cap2.png",
          created_at: "2025-06-20T11:00:00Z",
        },
      ];

      setBlogs(dummyBlogs);
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  // Pagination Logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />

      {/* Background Pattern Section */}
      <section className="searchcontainer">
        <span className="seachpattern">{/* SVG */}</span>
        <span className="seachpattern seachpatternrt">{/* SVG */}</span>
        <div className="container"></div>
      </section>

      {/* Title Section */}
      <section className="about-hero blog">
        <div className="container">
          <h1>Latest Blog Posts</h1>
          <p className="small">
            Stay updated with our news, tips, and insights
          </p>
        </div>
      </section>

      {/* Blog List Section */}
      <section className="blog-list-section py-5">
        <div className="container">
          {loading ? (
            <p className="text-center text-white">Loading blogs...</p>
          ) : blogs.length === 0 ? (
            <p>No blogs available.</p>
          ) : (
            <>
              <div className="row">
                {currentBlogs.map((blog) => (
                  <div className="col-md-4 mb-4" key={blog.id}>
                    <div className="card h-100 shadow-sm border-0">
                      <div
                        className="card-img-container mt-5"
                        style={{ height: "200px", overflow: "hidden" }}
                      >
                        <img
                          src={blog.image_url}
                          className="card-img-top"
                          alt={blog.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">{blog.title}</h5>
                        <p className="card-text flex-grow-1">
                          {blog.short_description?.slice(0, 100)}...
                        </p>
                        <p className="text-muted small mb-2">
                          {new Date(blog.created_at).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            }
                          )}
                        </p>
                        <a href="#" className="btn btn-outline-danger mt-auto">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {/* <div className="mt-5 d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, index) => (
                      <li
                        key={index + 1}
                        className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}
                      >
                        <button className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div> */}

              <div className="mt-3 d-flex justify-content-center">
                <nav>
                  <ul className="pagination custom-pagination">
                    {Array.from({ length: totalPages }, (_, index) => (
                      <li
                        key={index + 1}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Blog;
